// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-error[data-v-737c9bcf]{width:100%;max-width:480px;margin:0 auto;display:flex;flex-direction:column;align-items:center;justify-content:center;height:calc(100vh - 60px);padding:0 15px}.content-error img[data-v-737c9bcf]{width:30%}.volo-button.error[data-v-737c9bcf]{width:60%!important}", ""]);
// Exports
module.exports = exports;
